export interface ProfileCompletion {
  totalPercentage: number;
  tabs: {
    personal: number;
    employer: number;
    family: number;
    education: number;
    bank: number;
    documents: number;
  };
}

export interface EmployeeModel {
  id: number;
  name: string;
  email: string;
  shift: string;
  designation: string;
  department: string;
  branch: string;
  payrollCompany: string;
  usCompany: string;
  status: string;
  presence: string;
  avatarUrl: string;
  empCode: string;
  phone: string;
  profileCompletion: ProfileCompletion;
}

export interface IEmployeeData {
  employee: EmployeeModel[];
  totalCount: number;
}

export interface StatusDD {
  id: number;
  employeeStatus: string;
}

export const sortOptions = [
  'Profile Completion (lowest to highest)',
  'Profile Completion (highest to lowest)',
  'Name (A–Z)',
  'Name (Z–A)',
];
export const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
  'Name (A–Z)': { field: 'name', order: 1 },
  'Name (Z–A)': { field: 'name', order: -1 },
  'Profile Completion (lowest to highest)': { field: 'profileCompletion', order: 1 },
  'Profile Completion (highest to lowest)': { field: 'profileCompletion', order: -1 },
};
